<!-- Personal experience - 个人经历 -->
<template>
  <div class="info-personal-exp">
    <h1>Personal experience</h1>
    <div class="dis-96">
      <div class="dis-36">1. Awards, distinctions, honors</div>
      <div v-for="(item,index) in info.awards" :key="index">
        <ul class="ul-item dis-48">
          <li>
            <div>Award and Reason</div>
            <div>{{item.name}}</div>
          </li>
          <li>
            <div>Year</div>
            <div>{{item.description}}</div>
          </li>
        </ul>
      </div>

    </div>
    <div class="dis-96">
      <div class="dis-36">2. Interests/Hobbies</div>
      <div v-for="(item,index) in info.hobbies" :key="index">
        <ul class="ul-item dis-48">
          <li>
            <div>Hobby</div>
            <div>{{item.name}}</div>
          </li>
          <li>
            <div>Length of time</div>
            <div>{{item.description}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="dis-96">
      <div class="dis-36">3. Languages other than Chinese and English</div>
      <div v-for="(item,index) in info.languages" :key="index">
        <ul class="ul-item dis-48">
          <li>
            <div>Language</div>
            <div>{{item.name}}</div>
          </li>
          <li>
            <div>Proficiency</div>
            <div>{{item.description}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="dis-96">
      <div class="dis-36">4. Places Lived</div>
      <div v-for="(item,index) in info.placesLived" :key="index">
        <ul class="ul-item dis-48">
          <li>
            <div>Country</div>
            <div>{{item.name}}</div>
          </li>
          <li>
            <div>Length</div>
            <div>{{item.description}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="dis-96">
      <div class="dis-36">5. Numbers of countries and continents travelled</div>
      <ul class="ul-item dis-48">
        <li>
          <div>Country</div>
          <div>{{info.countriesCount}}</div>
        </li>
        <li>
          <div>Continents</div>
          <div>{{info.stateCount}}</div>
        </li>
      </ul>
    </div>
    <div class="dis-96">
      <div class="dis-36">6. Other significant credentials</div>
      <div v-for="(item,index) in info.significantCredentials" :key="index">
        <ul class="ul-item dis-48">
          <li>
            <div>Credential</div>
            <div>{{item.name}}</div>
          </li>
          <li>
            <div>Year</div>
            <div>{{item.description}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="dis-96">
      <div class="dis-36">7. Any other talents not mentioned</div>
      <div v-for="(item,index) in info.otherTalent" :key="index">
        <ul class="ul-item dis-48">
          <li>
            <div>Talent</div>
            <div>{{item.name}}</div>
          </li>
          <li>
            <div>Length of time</div>
            <div>{{item.description}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="dis-96">
      <div class="dis-36">8.List all activities you have participated in during the past 4 summers</div>
      <ul class="ul-item dis-48">
        <li>
          <div>Freshman</div>
          <div>{{info.freshman}}</div>
        </li>
        <li>
          <div>Sopomore</div>
          <div>{{info.sopomore}}</div>
        </li>
        <li>
          <div>Junior</div>
          <div>{{info.junior}}</div>
        </li>
        <li>
          <div>Senior</div>
          <div>{{info.senior}}</div>
        </li>
      </ul>
    </div>
    <div class="dis-96">
      <div class="dis-36">9. What are your favorite readings (books, publications, etc.)</div>
      <ul class="ul-item dis-48">
        <li>
          <div>Book by author/pulbication</div>
          <div>{{info.book1}}</div>
        </li>
        <li>
          <div>Book by author/pulbication</div>
          <div>{{info.book2}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { infoQueryPersonalexp } from '@/api/mentee'
export default {
  name: 'mentee-info-personal-exp',
  components: {},
  data () {
    return {
      info: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      let param = {
        num: this.$route.params.id
      }
      infoQueryPersonalexp(param).then(res => {
        let data = res.data.model || {}
        this.info = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
